import { createAction } from '@reduxjs/toolkit';

export const setAlert = createAction('cart/setAlert');
